interface SubProps {
  text: string
}

export default function Sub({ text }: SubProps) {
  return (
    <h4 className="inline-block my-1 text-lg font-bold text-blue-200 md:text-xl">
      {text}
    </h4>
  )
}
